module.exports = __webpack_public_path__ + "static/prototypeFallback@2x-d0608a87c55df060ac9b97eaf399e973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/prototypeFallback@2x.jpg
// module id = 2617
// module chunks = 168707334958949